import { UsersRepo } from "@/repos/UsersRepo";
import { UserModel } from "@/models/UserModels";
import { resolveType } from "./ServiceContainer";
import { CacheRepo } from "@/repos/base/CacheRepo";

// src/services/UserService.ts
export class UserService {
    constructor(private usersRepo: UsersRepo) { }

    async get(id: string): Promise<UserModel | null> {
        return await this.usersRepo.getById(id);
    }

    async getByEncodedEmail(encodedEmail: string): Promise<UserModel | null> {
        return await this.usersRepo.getByEncodedEmail(encodedEmail);
    }

    async create(item: UserModel): Promise<void> {
        return await this.usersRepo.create(item, item.uid);
    }

    async update(id: string, updates: Partial<UserModel>): Promise<void> {
        return await this.usersRepo.update(id, updates);
    }

    async delete(id: string): Promise<void> {
        return await this.usersRepo.delete(id);
    }

    async signIn(user: UserModel): Promise<void> {
        console.log('signIn', user);
    }

    async signOut(): Promise<void> {
        // clean up any cached data
        const cacheRepo = resolveType(CacheRepo);
        await cacheRepo.deleteByPrefix('user_');
        await cacheRepo.deleteByPrefix('userDashboard_');
        await cacheRepo.deleteByPrefix('round_');
        await cacheRepo.deleteByPrefix('league_');
        await cacheRepo.deleteByPrefix('course_');
        await cacheRepo.deleteByPrefix('leagueMembership_');
        await cacheRepo.deleteByPrefix('pendingUserData');
    }
}